
export enum ExtraGridConditionType {
    DEFAULT = 'default',
    VIEW = 'view',
    EDIT = 'edit'
}
export enum ExtraGridConditionType {
    DEFAULT = 'default',
    VIEW = 'view',
    EDIT = 'edit'
}